import { BasicConfig } from '@shared/models/basic-config.interface';
import { ExperienceFilter } from '@shared/models/experience-filter';

export abstract class CandidatesConfig extends BasicConfig {
  privileges: {
    assigned: {
      // TODO(MOJAT-3794): rename to shortlist after deploying epic
      candidates: string;
      jobs: string;
    };
    associate: {
      candidate_to_job: string;
      jobs_to_candidate: string;
    };
    candidates: {
      view: string;
      create: string;
      edit: string;
      notes: string;
      resumes: string;
      files: string;
      filesReadOnly: string;
      badges: string;
      fullBadges: string;
      inviteToApply: string;
    };
  };
  filter: {
    experience: ExperienceFilter;
  };
}

export type CandidatesPrivileges = CandidatesConfig['privileges'];
